/**
 * Unita di misura dei materiali, in un posto solo.
 * Aggiungerne una significava prima toccare sette elenchi paralleli fra client e server,
 * con il rischio che uno restasse indietro e mostrasse un'unita vuota.
 * L'ordine di questo elenco e quello con cui compaiono nei menu a tendina.
 */
export const MATERIAL_UNIT_VALUES = ["litre", "kilogram", "metre", "cubic_metre", "piece", "container"] as const;

export type MaterialUnit = (typeof MATERIAL_UNIT_VALUES)[number];

/** Nomi per esteso, usati nei moduli e nelle colonne. */
export const MATERIAL_UNIT_LABELS: Record<MaterialUnit, string> = {
  litre: "Litri",
  kilogram: "Chilogrammi",
  metre: "Metri",
  cubic_metre: "Metri cubi",
  piece: "Pezzi",
  container: "Contenitori",
};

/** Nomi al singolare, per le frasi tipo "prezzo per litro". */
export const MATERIAL_UNIT_SINGULAR_LABELS: Record<MaterialUnit, string> = {
  litre: "litro",
  kilogram: "kg",
  metre: "metro",
  cubic_metre: "m³",
  piece: "pezzo",
  container: "contenitore",
};

/** Plurali minuscoli, per le frasi tipo "20 litri" negli ordini e nei riepiloghi. */
export const MATERIAL_UNIT_PLURAL_LABELS: Record<MaterialUnit, string> = {
  litre: "litri",
  kilogram: "kg",
  metre: "metri",
  cubic_metre: "m³",
  piece: "pezzi",
  container: "contenitori",
};

/** Sigle brevi, per le card e le righe strette. */
export const MATERIAL_UNIT_COMPACT_LABELS: Record<MaterialUnit, string> = {
  litre: "L",
  kilogram: "kg",
  metre: "m",
  cubic_metre: "m³",
  piece: "pz",
  container: "cont.",
};
